import "./index.css";
import { Box, Card, CardContent, Grid2, Typography } from "@mui/material";
import backBgImage from "../../../assets/3.png";
import img1 from "../../../assets/customer-service.png";
import img2 from "../../../assets/financial-planner.png";
import img3 from "../../../assets/financial-analysis.png";
import img4 from "../../../assets/investments.png";

const WhyChooseUs = () => {
  return (
    <Box className="why-choose-us-container section-divide">
      <Box className="bg-extra-img">
        <img src={backBgImage} alt="" />
      </Box>
      <Box className="container">
        <Grid2 container columnSpacing={4} sx={{ padding: "0 15px" }}>
          <Grid2 size={{ lg: 6, md: 6, sm: 12 }}>
            <Box className="mb-30" sx={{ padding: "0 15px" }}>
              <Box className="section-title-s2 sec-span-color sec-tittle-color text-left">
                <Typography variant="h2">Why Choose Us</Typography>
                <p>
                  Unlock a competitive advantage tailored to your needs while
                  benefiting from substantial cost savings.
                </p>
              </Box>
            </Box>
          </Grid2>
          <Grid2 size={{ lg: 3, md: 3, sm: 6, xs: 12 }}>
            <Grid2 container minWidth={"100%"}>
              <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                <Card className="card card-1">
                  <CardContent>
                    <div className="about-cop">
                      <div className="icon d-flex align-items-center">
                        {/* <CountUp end={90} suffix='%'/> */}
                        <img src={img3} alt="financial analysis" />
                      </div>
                      <div className="text media-body">
                        <h3>Financial Analysis</h3>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </Grid2>
              <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                <Card className="card card-2">
                  <CardContent>
                    <div className="about-cop">
                      <div className="icon d-flex align-items-center">
                        <img src={img4} alt="financial analysis" />
                      </div>
                      <div className="text media-body">
                        <h3>Investments</h3>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 size={{ lg: 3, md: 3, sm: 6, xs: 12 }}>
            <Grid2 container minWidth={"100%"}>
              <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                <Card className="card card-3">
                  <CardContent>
                    <div className="about-cop">
                      <div className="icon d-flex align-items-center">
                        <img src={img2} alt="financial Planner" />
                      </div>
                      <div className="text media-body">
                        <h3>Financial Planner</h3>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </Grid2>
              <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                <Card className="card card-4">
                  <CardContent>
                    <div className="about-cop">
                      <div className="icon d-flex align-items-center">
                        <img src={img1} alt="Business Support" />
                      </div>
                      <div className="text media-body">
                        <h3>Business Support</h3>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
      </Box>
    </Box>
  );
};

export default WhyChooseUs;
